/* =========================================================
   FILE: assets/bundle-builder.js
   Upload via Shopify Admin -> Edit Code -> Assets -> Add a new asset
   -----------------------------------------------------------
   ARCHITECTURE: ONE pool of products. Selection 1 defaults to
   a configured handle, Selection 2 defaults to another. Each
   selection has its OWN design picker grid below it — tapping
   a thumbnail swaps only that selection's product. Both grids
   show the FULL pool — the same product can be picked in both
   selections (duplicates allowed). Both variants are added to
   cart together once both sizes are picked.
   ========================================================= */

(function () {
  "use strict";

  var CONFIG = window.BUNDLE_CONFIG || {};

  var poolProducts = [];        // all fetched pool products, in config order
  var selections = {
    1: { product: null, sizeIndex: -1, size: null, variant: null },
    2: { product: null, sizeIndex: -1, size: null, variant: null }
  };

  function moneyFormat(cents) {
    return "₹" + (cents / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 });
  }

  // -----------------------------------------------------------------
  // FETCH ALL PRODUCTS IN THE POOL
  // -----------------------------------------------------------------
  function fetchProduct(handle) {
    return fetch("/products/" + handle + ".js")
      .then(function (res) {
        if (!res.ok) throw new Error("Product not found: " + handle);
        return res.json();
      })
      .catch(function (err) {
        console.error(err);
        return null;
      });
  }

  function loadPool() {
    var handles = (CONFIG.pool && CONFIG.pool.products) || [];
    Promise.all(handles.map(fetchProduct)).then(function (results) {
      poolProducts = results.filter(Boolean);

      var defaults = CONFIG.defaultHandles || [];
      var defaultProduct1 = poolProducts.find(function (p) { return p.handle === defaults[0]; }) || poolProducts[0];
      var defaultProduct2 = poolProducts.find(function (p) { return p.handle === defaults[1]; }) || poolProducts[1];

      if (defaultProduct1) fillSlot(1, defaultProduct1);
      if (defaultProduct2) fillSlot(2, defaultProduct2);

      renderPoolGrid(1);
      renderPoolGrid(2);
    });
  }

  // -----------------------------------------------------------------
  // RENDER THE GRID OF DESIGNS FOR ONE SLOT
  // (shows ALL pool designs — same product can be picked in both slots)
  // -----------------------------------------------------------------
  function renderPoolGrid(slotNum) {
    var grid = document.getElementById("pool-grid-" + slotNum);
    grid.innerHTML = "";

    poolProducts.forEach(function (product) {
      var card = document.createElement("button");
      card.type = "button";
      card.className = "pool-card";
      card.setAttribute("data-handle", product.handle);

      var thumb = product.featured_image || (product.images && product.images[0]);
      var img = document.createElement("img");
      img.src = thumb || "";
      img.alt = product.title;
      img.loading = "lazy";

      card.appendChild(img);

      var isActive = selections[slotNum].product && selections[slotNum].product.handle === product.handle;
      card.classList.toggle("is-selected", isActive);

      card.addEventListener("click", function () {
        fillSlot(slotNum, product);
        renderPoolGrid(slotNum);
      });

      grid.appendChild(card);
    });
  }

  // -----------------------------------------------------------------
  // FILL A SELECTION SLOT WITH A PRODUCT
  // -----------------------------------------------------------------
  function fillSlot(slotNum, product) {
    var s = selections[slotNum];
    s.product = product;
    s.size = null;
    s.variant = null;

    var sizeIndex = product.options.findIndex(function (o) {
      return /size/i.test(o.name);
    });
    s.sizeIndex = sizeIndex;

    document.getElementById("title-" + slotNum).textContent = product.title;

    // If CONFIG.displayUnitPrice is set (campaign/anchor price), show that
    // instead of the real Shopify variant price. Real price is still what
    // actually gets added to cart/checkout — this is a display-only override.
    var unitPriceCents = (CONFIG.displayUnitPrice != null) ? CONFIG.displayUnitPrice : product.price;
    document.getElementById("price-" + slotNum).textContent = moneyFormat(unitPriceCents);

    var images = (product.images || []).slice(0, 5);
    var gallery = document.getElementById("gallery-" + slotNum);
    gallery.innerHTML = "";
    images.forEach(function (src) {
      var img = document.createElement("img");
      img.src = src;
      img.loading = "lazy";
      img.alt = product.title;
      gallery.appendChild(img);
    });

    renderDots(slotNum, images.length);

    document.getElementById("size-selected-" + slotNum).textContent = "";
    renderSizes(slotNum, product, sizeIndex);

    // update sticky bar preview thumbnail + name immediately on product pick
    var stickyThumb = document.getElementById("stickybar-thumb-" + slotNum);
    var stickyName = document.getElementById("stickybar-name-" + slotNum);
    var thumbSrc = product.featured_image || images[0];
    if (stickyThumb) stickyThumb.style.backgroundImage = thumbSrc ? "url(" + thumbSrc + ")" : "";
    if (stickyName) stickyName.textContent = "Oversized Printed T-shirt";

    updateSummary();
  }

  // -----------------------------------------------------------------
  // IMAGE DOTS (visual indicator only — no click behavior, no active state)
  // -----------------------------------------------------------------
  function renderDots(slotNum, count) {
    var wrap = document.getElementById("dots-" + slotNum);
    if (!wrap) return;
    wrap.innerHTML = "";
    for (var i = 0; i < count; i++) {
      var dot = document.createElement("span");
      dot.className = "gallery-dot";
      wrap.appendChild(dot);
    }
  }

  // -----------------------------------------------------------------
  // SIZE BUTTONS FOR A SLOT
  // -----------------------------------------------------------------
  function renderSizes(slotNum, product, sizeIndex) {
    var wrap = document.getElementById("size-buttons-" + slotNum);
    wrap.innerHTML = "";

    if (sizeIndex === -1) {
      // single-variant product, auto-select
      selections[slotNum].variant = product.variants[0];
      updateSummary();
      return;
    }

    var seen = {};
    product.options[sizeIndex].values.forEach(function (value) {
      if (seen[value]) return;
      seen[value] = true;

      var btn = document.createElement("button");
      btn.className = "size-btn";
      btn.type = "button";
      btn.textContent = value;
      btn.setAttribute("data-value", value);

      var match = product.variants.find(function (v) {
        return v["option" + (sizeIndex + 1)] === value;
      });
      if (!match || !match.available) {
        btn.classList.add("is-disabled");
      }

      btn.addEventListener("click", function () {
        if (btn.classList.contains("is-disabled")) return;
        selectSize(slotNum, value, btn);
      });

      wrap.appendChild(btn);
    });
  }

  function selectSize(slotNum, value, btnEl) {
    var s = selections[slotNum];
    s.size = value;

    document.querySelectorAll("#size-buttons-" + slotNum + " .size-btn").forEach(function (el) {
      el.classList.remove("is-selected");
    });
    btnEl.classList.add("is-selected");
    document.getElementById("size-selected-" + slotNum).textContent = "· " + value;

    var match = s.product.variants.find(function (v) {
      return v["option" + (s.sizeIndex + 1)] === value;
    });
    s.variant = (match && match.available) ? match : null;

    var stickySize = document.getElementById("stickybar-size-" + slotNum);
    if (stickySize) stickySize.textContent = s.variant ? ("Size " + value) : "Pick size";

    updateSummary();
  }

  // -----------------------------------------------------------------
  // SUMMARY + STICKY BAR
  // -----------------------------------------------------------------
  function updateSummary() {
    var allSelected = true;
    var realTotal = 0; // sum of both real variant prices (in cents, Shopify format)

    [1, 2].forEach(function (slotNum) {
      var s = selections[slotNum];
      if (!s.variant) allSelected = false;
      else realTotal += s.variant.price;
    });

    var stickyTotal = document.getElementById("sticky-total");
    var stickyMrp = document.getElementById("sticky-mrp");
    var addBtn = document.getElementById("btn-add-bundle");

    if (allSelected) {
      // MRP shown struck-through: if a fixed display unit price is set
      // (campaign/anchor price), show 2x that instead of the real sum —
      // keeps the "MRP" consistent with the per-product price shown above.
      var mrpTotal = (CONFIG.displayUnitPrice != null) ? (CONFIG.displayUnitPrice * 2) : realTotal;

      // Final total: if CONFIG.flatBundleTotal is set (e.g. BOGO campaigns
      // where the pair should always total a fixed amount like ₹1799),
      // use that directly. Otherwise fall back to the original
      // percentage-off-real-price behavior.
      var discountedTotal;
      if (CONFIG.flatBundleTotal != null) {
        discountedTotal = CONFIG.flatBundleTotal;
      } else {
        var discountPercent = CONFIG.discountPercent || 0;
        discountedTotal = Math.round(realTotal * (1 - discountPercent / 100));
      }

      stickyMrp.textContent = moneyFormat(mrpTotal);
      stickyMrp.style.display = "inline";
      stickyTotal.textContent = moneyFormat(discountedTotal);
    } else {
      stickyMrp.style.display = "none";
      stickyTotal.textContent = "₹0";
    }

    addBtn.disabled = !allSelected;
    addBtn.textContent = allSelected ? "Add Bundle →" : "Select Size to Continue";
  }

  // -----------------------------------------------------------------
  // ADD BOTH VARIANTS TO CART, REDIRECT WITH DISCOUNT CODE
  // -----------------------------------------------------------------
  function addBundleToCart() {
    var v1 = selections[1].variant;
    var v2 = selections[2].variant;
    if (!v1 || !v2) return;

    var payload = {
      items: [
        { id: v1.id, quantity: 1 },
        { id: v2.id, quantity: 1 }
      ]
    };

    setLoading(true);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        setLoading(false);
        openMiniCart();
      })
      .catch(function (err) {
        console.error("Add to cart failed:", err);
        setLoading(false);
        alert("Something went wrong adding the bundle to cart. Please try again.");
      });
  }

  function setLoading(isLoading) {
    var btn = document.getElementById("btn-add-bundle");
    btn.disabled = isLoading;
    btn.textContent = isLoading ? "Adding..." : "Add Bundle";
  }

  // -----------------------------------------------------------------
  // ADDED-TO-CART MODAL (simple confirmation, bypasses Horizon drawer issues)
  // -----------------------------------------------------------------
  function openMiniCart() {
    document.getElementById("minicart-overlay").classList.add("is-open");
    document.getElementById("minicart-panel").classList.add("is-open");
  }

  function closeMiniCart() {
    document.getElementById("minicart-overlay").classList.remove("is-open");
    document.getElementById("minicart-panel").classList.remove("is-open");
  }

  // -----------------------------------------------------------------
  // BANNER + MARQUEE
  // -----------------------------------------------------------------
  function renderBanner() {
    var img1 = document.getElementById("bundle-banner-img-1");
    var img2 = document.getElementById("bundle-banner-img-2");
    var images = CONFIG.bannerImages || [];
    if (img1 && images[0]) img1.src = images[0];
    if (img2 && images[1]) img2.src = images[1];
  }

  function renderMarquee() {
    var track = document.getElementById("marquee-track");
    if (!track || !CONFIG.marqueeItems || !CONFIG.marqueeItems.length) return;
    var itemsHtml = CONFIG.marqueeItems.map(function (text) {
      return '<span class="bundle-marquee__item">' + text + '</span>';
    }).join("");
    track.innerHTML = itemsHtml + itemsHtml;
  }

  // -----------------------------------------------------------------
  // FAQ ACCORDION
  // -----------------------------------------------------------------
  function renderFAQ() {
    var list = document.getElementById("faq-list");
    if (!list || !CONFIG.faqItems) return;

    CONFIG.faqItems.forEach(function (item, index) {
      var row = document.createElement("div");
      row.className = "faq-item";

      var card = document.createElement("button");
      card.type = "button";
      card.className = "faq-item__card";

      var question = document.createElement("span");
      question.className = "faq-item__question";
      question.textContent = item.question;

      var chevron = document.createElement("span");
      chevron.className = "faq-item__chevron";
      chevron.textContent = "+";

      card.appendChild(question);
      card.appendChild(chevron);

      var answer = document.createElement("div");
      answer.className = "faq-item__answer";
      answer.innerHTML = item.answer;

      row.appendChild(card);
      row.appendChild(answer);

      card.addEventListener("click", function () {
        var isOpen = row.classList.contains("is-open");
        // close any other open FAQ first (accordion behavior — one open at a time)
        document.querySelectorAll(".faq-item.is-open").forEach(function (openRow) {
          if (openRow !== row) {
            openRow.classList.remove("is-open");
            openRow.querySelector(".faq-item__chevron").textContent = "+";
          }
        });
        row.classList.toggle("is-open", !isOpen);
        chevron.textContent = !isOpen ? "−" : "+";
      });

      list.appendChild(row);
    });
  }

  // -----------------------------------------------------------------
  // INIT
  // -----------------------------------------------------------------
  document.addEventListener("DOMContentLoaded", function () {
    renderBanner();
    renderMarquee();
    renderFAQ();
    loadPool();
    document.getElementById("btn-add-bundle").addEventListener("click", addBundleToCart);
    document.getElementById("minicart-overlay").addEventListener("click", closeMiniCart);

    document.getElementById("minicart-view-cart").addEventListener("click", function (e) {
      e.preventDefault();
      var href = this.getAttribute("href");
      closeMiniCart();
      setTimeout(function () {
        window.location.href = href;
      }, 150); // small delay so the close animation/state isn't visible mid-navigation
    });

    var pairCtaBtn = document.getElementById("btn-pair-cta");
    if (pairCtaBtn) {
      pairCtaBtn.addEventListener("click", function () {
        var target = document.getElementById("selection-1");
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }
  });

  // Forces the modal closed if the browser restores this page from
  // back/forward cache (e.g. customer hits "back" from /cart) — bfcache
  // restores keep the old .is-open classes since DOMContentLoaded doesn't
  // fire again, so we explicitly reset on pageshow.
  window.addEventListener("pageshow", function () {
    closeMiniCart();
  });
})();


// sizechart js

const bundleSizechartModal = document.getElementById('bundle-sizechart-modal');
const bundleSizechartClose = document.querySelector('.bundle-sizechart-close');

document.querySelectorAll('.bundle-sizechart-open').forEach(trigger => {
  trigger.addEventListener('click', () => {
    bundleSizechartModal.style.display = 'flex';
  });
});

bundleSizechartClose.addEventListener('click', () => {
  bundleSizechartModal.style.display = 'none';
});

bundleSizechartModal.addEventListener('click', (e) => {
  if (e.target === bundleSizechartModal) {
    bundleSizechartModal.style.display = 'none';
  }
});